import React from 'react';
import { RefreshNavLink as NavLink } from './RefreshLink';
import { IcTruck, IcFlask } from '../theme/icons';

// Contrôle segmenté « Fournisseurs | Laboratoires » — les deux destinations
// sont visibles côte à côte et la page courante est surlignée, même style que
// la bascule Produits/Soins des réservations. `full` étire le contrôle sur
// toute la largeur (en-têtes mobiles).
const OPTIONS = [
  { to: '/suppliers', label: 'Fournisseurs', icon: IcTruck },
  { to: '/laboratoires', label: 'Laboratoires', icon: IcFlask },
];

// `variant="chips"` (owner 2026-09-09, /suppliers) : les deux destinations en
// chips .tab-chip / .tab-chip-on — exactement les onglets de VenteTabs sur
// « Nouvelle vente » (42px, rayon 16, actif = blanc bordé encre 2px, inactif
// = gris sans fond), gap-2. Les en-têtes mobiles gardent la bascule `.seg`.
const FournisseursLabosSwitch = ({ full = false, variant = 'seg' }) => (
  variant === 'chips' ? (
    <div className="inline-flex gap-2 items-center" aria-label="Basculer entre fournisseurs et laboratoires">
      {OPTIONS.map((o) => (
        <NavLink
          key={o.to}
          to={o.to}
          className={({ isActive }) => `shrink-0 ${isActive ? 'tab-chip-on' : 'tab-chip'}`}
        >
          <o.icon size={13} /> {o.label}
        </NavLink>
      ))}
    </div>
  ) : (
  <div
    className={`${full ? 'w-full' : ''} seg`}
    aria-label="Basculer entre fournisseurs et laboratoires"
  >
    {OPTIONS.map((o) => (
      <NavLink
        key={o.to}
        to={o.to}
        className={({ isActive }) =>
          `${full ? 'flex-1 justify-center' : ''} inline-flex items-center gap-2 transition-colors ${
            isActive ? 'seg-on' : 'seg-off'
          }`
        }
      >
        <o.icon size={13} /> {o.label}
      </NavLink>
    ))}
  </div>
  )
);

export default FournisseursLabosSwitch;
